import { Divider, Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import './Discover.scss';
import { ExperienceList } from './ExperienceList/ExperienceList';
import { FormPictureField } from './FormPictureField';

export const Discover = () => {
  const form = Form.useFormInstance<Partial<PackResponse>>();
  const hotelId = Form.useWatch('hotelId', form);
  const introPictures = Form.useWatch('introPictures', form);

  return (
    <SCard
      title="Discover"
      subtitle="Gallery that gathers pictures of all the packages included in this hotel"
      className="scard-cover-with-pictures"
    >
      <div className="staycation-discover-card__container">
        <div className="staycation-discover-card__title">Introduction</div>
        <FormPictureField
          name="introPictures"
          sectionTitle="Introduction pictures"
          hotelId={hotelId}
          multiple
          value={introPictures}
        />
      </div>

      <Divider />

      <ExperienceList />
    </SCard>
  );
};
